import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import LayoutLogin from "./layoutLogin";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { convertPersian, formatMsisdn, formatString, isEmpty, validateInput } from "../../tools/tools";
import { useAPIPublic } from "../../tools/api";
import { _adr, _ckey } from "../../address";
import { app_Cookie, app_Cookie_Remove, setAuthorization, setToken } from "../../tools/services";
import { useDispatch } from "react-redux";
import { globalValue } from "../../reducer/serviceReducerGlobala";

const TwoStepConfirm = () => {
	const [t] = useTranslation("global");
	const { resendOTPCode, confirmOTPCode, queryCurrentUser, queryUserRoles } = useAPIPublic();
	const location = useLocation();
	const nav = useNavigate();
	const dispatch = useDispatch();

	// ======== props ========
	const [sessionid, setSessionid] = useState(location.state?.sessionid || 0);
	const [expiretime, setExpiretime] = useState(location.state?.expiretime || 0);
	const [loginState, setLoginState] = useState(location.state?.loginState);
	const [msisdn, setMsisdn] = useState(location.state?.msisdn || 0);
	// ======== props ========

	// ======== state ========
	const [seconds, setSeconds] = useState(0);
	const [minutes, setMinutes] = useState(0);
	const [resendActive, setResendActive] = useState(false);
	const [remainTimeActive, setRemainTimeActive] = useState(false);
	const [isProgress, setIsProgress] = useState(false);
	// ======== state ========

	useEffect(() => {
		//Create interval For Time Counter
		setResendActive(false);
		let timer;
		const TimeCounter = () => {
			let dt = new Date();
			let expTime = 0;
			if (!isEmpty(app_Cookie(_ckey.expiretimeLogin)) && !isEmpty(app_Cookie(_ckey.expiretimeLogin)) > 0) {
				// console.log(app_Cookie(_ckey.expiretimeLogin));
				// expTime = app_Cookie(_ckey.expiretimeLogin);
				expTime = Math.round(expiretime - 60);
			} else {
				expTime = Math.round(expiretime - 60);
			}
			let counterDown = dt.setSeconds(dt.getSeconds() + expTime);
			let timer = setInterval(() => {
				let now = new Date().getTime();
				let distance = counterDown - now;

				let minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				setMinutes(minute);

				let second = Math.floor((distance % (1000 * 60)) / 1000);
				setSeconds(second);

				app_Cookie(_ckey.expiretimeLogin, minute * 60);

				if (distance < 0) {
					setMinutes(0);
					setSeconds(0);
					clearInterval(timer);
					setResendActive(true);
					setRemainTimeActive(false);
				}
			}, 1000);
			setRemainTimeActive(true);
		};
		TimeCounter();
		return () => clearInterval(timer);
	}, [expiretime]);

	const resendOTP = async (e) => {
		e.preventDefault();
		let payload = {
			sessionid: sessionid,
			expiretimebyminute: parseInt(process.env.REACT_APP_LOGIN_EXPIRE),
		};
		let response = await resendOTPCode(payload);
		console.log(response);
		if (response) {
			setSessionid(response.sessionid);
			setExpiretime(parseInt(response.expiretime.split(":")[1]) * 60);
		}
	};
	const handleSubmit = async (param) => {
		try {
			setIsProgress(true);
			let payload = {
				sessionid: sessionid,
				otpvalue: param.otpvalue,
			};
			let response = await confirmOTPCode(payload);

			if (response && !response.HasError) {
				app_Cookie(_ckey.token, response.token);
				setAuthorization(response.token);
				if (!loginState && response && !response.HasError) {
					nav(_adr.Root + _adr.Login.ResetPassword, { replace: true });
				} else {
					await setToken({
						token: response.token,
						expireUTCTime: response.expireUTCTime,
					});
					setAuthorization(response.token);
					let resUser = await queryCurrentUser();
					if (resUser) {
						let resRoles = await queryUserRoles();
						if (resRoles) {
							dispatch(globalValue({ _currentUser: { ...resUser, roles: [...resRoles] } }));
							if (!resUser.phonenumberconfirmed) nav(_adr.Root + _adr.Login.ResetPassword, { replace: true });
							else nav(_adr.Root + _adr.Home);
						}
					}
				}
				app_Cookie_Remove(_ckey.expiretimeLogin);
				// if (loginState)
				// else console.log(response);
			}
			setIsProgress(false);
		} catch (error) {
			setIsProgress(false);
		}
	};
	return (
		<>
			<LayoutLogin>
				<div className="holder-title-form">
					<h3
						dangerouslySetInnerHTML={{
							__html: formatString(t("form.otpMsisdn"), formatMsisdn(msisdn)),
						}}></h3>
				</div>
				<Form name="normal_login" className="login-form" onFinish={handleSubmit}>
					<Form.Item
						name="otpvalue"
						className="input-normal"
						rules={[
							validateInput({
								t: t,
								type: "number",
							}),
						]}
						extra={
							<>
								{resendActive && (
									<a onClick={resendOTP} href="/#">
										ارسال مجدد کد تایید
									</a>
								)}
							</>
						}>
						<div>
							<Input
								dir="ltr"
								prefix={<i className="icon-lock-3"></i>}
								placeholder={t("form.confirmOtp")}
								autoComplete="off"
								inputMode="numeric"
								onChange={(e) => {
									e.target.value = convertPersian(e.target.value);
								}}
								maxLength={5}
								allowClear
							/>
							<div className="holder-counter-down">
								{remainTimeActive && (
									<>
										<span className="remaintime">{("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2)}</span>
										<span className="remaintext"> مانده تا دریافت مجدد کد تایید</span>
									</>
								)}
							</div>
						</div>
					</Form.Item>

					<Form.Item>
						<Button type="default" htmlType="submit" className={`btn-normal btn-aptel ${isProgress && "disabled"}`} disabled={isProgress} danger>
							{isProgress ? t("form.inProgress") : t("form.loginButton")}
						</Button>
					</Form.Item>
				</Form>
			</LayoutLogin>
		</>
	);
};

export default TwoStepConfirm;
